class ImageCarousel{
    constructor(el) {
        this.scope = el;
        this.items = el.querySelector('[data-items]');
        this.navContainer = el.querySelector('[data-nav]');
        this.slider = new Slider(this.scope, this.items, {navContainer: this.navContainer, count: [1,1,1]});
    }
}
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-image-carousel]').forEach(el => new ImageCarousel(el));
})

